<template>
  <div :class="['components-page__flowHelper', isDisabled]">
    <div v-if="isCollapse" class="flow-collapse header-section">
      <span class="el-icon-cherry" />
      <span class="helper-title">流程助手</span>
      <i
        class="el-icon-arrow-right icon-right"
        @click="isCollapse = !isCollapse"
      />
    </div>
    <div v-else class="flow-expand">
      <div class="header-section">
        <span class="el-icon-cherry" />
        <span class="helper-title">流程助手</span>
        <i class="el-icon-close icon-right" @click="isCollapse = !isCollapse" />
      </div>
      <div class="flow-title">参考流程</div>
      <el-select
        v-model="value"
        placeholder="请选择"
        class="width-layout"
        filterable
        value-key="id"
        @change="handleChange"
      >
        <el-option
          v-for="item in approveList"
          :key="item.id"
          :label="item.name"
          :value="{ id: item.id, bizType: item.bizType }"
        />
      </el-select>
    </div>
  </div>
</template>

<script>
import { getAuditList } from '@/api/approvalApi'
import mixin from '../../../mixins/auditFlowManage'

export default {
  name: 'flowHelper',
  mixins: [mixin],
  props: {
    isDisabled: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      isCollapse: true,
      approveList: [],
      value: {},
    }
  },

  created() {
    this.loadList()
  },
  methods: {
    async loadList() {
      const { deptId } = this.$route.query
      const params = {
        pageNum: 1,
        pageSize: 1000,
        deptIdList: [deptId],
      }
      const res = await getAuditList(params)
      const { code, data } = res
      if (code === 1 && data && data.items) this.approveList = res.data.items || []
    },
    handleChange(item) {
      const { bizType, id } = item
      this.$store.dispatch('getAuditDetail', { id, bizType })
    },
  },
}
</script>

<style lang="scss" scoped>
@import '../index.scss';
.components-page__flowHelper {
  position: absolute;
  left: 16px;
  z-index: 1;
  background: #ffffff;
  box-shadow: 0px 0px 4px 0px rgba(10, 42, 97, 0.2);
  border-radius: 2px;
  padding: 10px 8px 10px 16px;
  margin-top: 20px;
  .header-section {
    display: flex;
    align-items: center;
  }
  .helper-title {
    font-weight: 500;
    margin: 0 20px 0 8px;
  }
  .icon-right {
    flex: 1;
    text-align: right;
    cursor: pointer;
  }
  .el-icon-arrow-right {
    color: #969799;
  }
  .el-icon-close {
    color: #646566;
  }
  .flow-collapse {
    width: 148px;
  }
  .flow-expand {
    width: 272px;
    padding-bottom: 6px;
  }
  .flow-title {
    margin: 16px 0 8px 0;
  }
  .width-layout {
    width: 100%;
  }
}
</style>
